import { render, staticRenderFns } from "./GatewayView.vue?vue&type=template&id=33fc1fef&scoped=true&"
import script from "./GatewayView.vue?vue&type=script&lang=ts&"
export * from "./GatewayView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fc1fef",
  null
  
)

export default component.exports